<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/"><img src="assets/img/logo.svg"></a>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="javascript:;" (click)="goToMarketplace()" style="cursor: pointer;">Marketplace</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="javascript:;" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu" style="width: 200px;">
            <ul>
              <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Icons/Navigation/Arrow Down/Black">
                    <g id="Group">
                      <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </g>
                </svg> -->
              </li>
              <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
              <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
        </li>
         <li class="nav-item signup-btn">
        <!-- <a class="nav-link button" data-toggle="modal" routerLink="/login" data-target="#signup-popup">Sign up for Free</a> -->
        </li>
        <li class="nav-item login-btn">
        <a class="nav-link btn" data-toggle="modal" (click)="loginLogout()" data-target="#loginmodal">{{currentValue}}</a>
        </li>
      </ul>
      </div>
    </div>
    </nav>
</header>

<section class="create-workspace-section">

		<div class="img-box">
			<img src="assets/img/Hero-Image.jpg">
		</div>

    <div class="img-box-left">
      <img src="assets/img/Hero-Image.jpg">
    </div>

    <div class="container">
  		<div class="row">
  			<div class="col-sm-12">
  				<div class="inner-content welcome-txt" style="background-color: #fff">
              <h6>Welcome to Workspace</h6>
    					<p class="create-space-by-crafttor">By Crafttor</p>
              <h4>Give a name to your workspace!</h4>
              <p class="create-space-p">To use the workspace for your assests you need to give name to your workspace.</p>
              <div class="create-workspace-txt">
                <p>Create a workspace</p>
              </div>
              <div class="btn-wrapper">
                <form style="width: 100%" class="form-horizontal" [formGroup]="creatwWorkspace" (ngSubmit)="createWorkspace(workspaceNames.value)">
                  <input maxlength="50" formControlName="message" placeholder="Your workspace name" data-test-name="invite-email-input" class="workspace-ant-input-invite" type="text" value="" #workspaceNames>
                </form>
              </div>
              <span class="text-danger error-text board-error-text" *ngIf="isShowCreateWorkspaceError">{{createWorkspaceErrorMessage}}</span>
              <span class="text-danger error-text board-error-text" *ngIf="isShowCreateLoginWorkspaceError" (click)="openLoginClass()" style="cursor: pointer;"><b>{{createWorkspaceLoginErrorMessage}}</b></span>
              <button *ngIf="!showLeaveLoader" style="width: 100%" [disabled]="workspaceNames.value === ''" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button" (click)="createWorkspace(workspaceNames.value)"><span role="img" aria-label="plus" class="create-workspace-span">Create Workspace</span></button>

              <button *ngIf="showLeaveLoader" style="width: 100%" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button">
                <img class="img-up-loader" style="height: 18px;" src="assets/img/img-up-white.svg" alt="">
              </button>

              <!-- <span class="ant-input-group-addon" style="background-color: #e4e4e4">
                <button [disabled]="workspacename === ''" data-test-name="send-invite-button" type="button" class="ant-btn-invite ant-btn-default ant-input-search-button" (click)="createWorkspace()"><span role="img" aria-label="plus" class="">Get started</span></button></span> -->
              <p *ngIf="screenId == '2'" class="change-later" style="cursor: pointer;"><a routerLink="/home">Back to Home</a></p>

              <p *ngIf="screenId == '1'" class="change-later" style="cursor: pointer;"><a (click)="backToWorkspace()">{{backWorkspaceName}}</a></p>
              <!-- <p class="change-later"><a routerLink="/">Back to Workspace</a></p> -->
  				</div>
  			</div>
  		</div>
  	</div>
</section>

<section>
  <div class="create-workspace-footer-heading">
    <div class="container">
      <div class="row">
        <div class="col-md-3 row-col">
          <!-- <span class="designer-name">
            Art By Crafttor
          </span> -->
        </div>
        <div class="col-md-6 row-col copyright text-center">
          copyright © 2025 Crafttor. All rights reserved. •<a href="javascript:;" target="_blank">Terms</a> • <a href="javascript:;" target="_blank" rel="noopener noreferrer">Privacy</a>
        </div>
      </div>
    </div>
  <!-- <div class="footer-chat">
    <span class="chat-bg">
      <span class="chat-icon"></span>
    </span>
  </div> -->
</div>
</section>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':loginStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="margin-top:200px; height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<button style="text-align: end;" type="button" class="close" (click)="closeLoginDialog()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="modal-body">
				<h3 style="margin-bottom:0px;">Login to continue</h3>
				<p style="margin-bottom:30px; margin-top:8px;">Please login to create workspace</p>
				<div class="button-wrapper">
					<a href="javascript:;" class="button google-login-btn" (click)="signInWithGoogle()"><i class="fa fa-google-plus"></i> Continue with Google</a>
					<!-- <p>By Login, I agree the <a href="javascript:;" (click)="openClose()" [routerLink]="['privacy-terms', {active: 'terms'}]">Terms of Use</a> & <a href="javascript:;" (click)="openClose()"
							[routerLink]="['privacy-terms', {active: 'privacy'}]">Privacy Policy</a>.</p> -->
				</div>
			</div>

		</div>
	</div>
</div>
